import React, { useState, useContext, useEffect } from 'react'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

import { useShallowEqualSelector } from 'custom-hooks'
import {
  getProfileGroupsSelector,
  selectLocationsById,
  getGroupIdByFacilityIdSelector,
} from 'redux/reducers/profile'
import { getFacilityIdSelector } from 'redux/reducers/facility'
import { GroupContext } from './FacilityDropDownMenu'
import FacilityItem from './FacilityItem'
import CustomScroll from '../CommonUI/CustomScroll/CustomScroll'

const GroupFacilityMenu = () => {
  const groups = useShallowEqualSelector(getProfileGroupsSelector) || []

  return (
    <CustomScroll className="facility-scroll-block">
      <div className="group_facility_menu_container">
        {groups.map((group) => {
          return <GroupList key={group.id} {...group} />
        })}
      </div>
    </CustomScroll>
  )
}

const GroupList = ({ id, name }) => {
  const selectedFacilityId = useShallowEqualSelector(getFacilityIdSelector)
  const groupIdByFacilityId = useShallowEqualSelector(
    getGroupIdByFacilityIdSelector(selectedFacilityId)
  )
  const searchValue = useContext(GroupContext)

  const [isOpen, setIsOpen] = useState(groupIdByFacilityId === id)

  const handleClickToggle = () => {
    setIsOpen((pr) => !pr)
  }

  const activeClassName = isOpen ? 'open' : ''

  useEffect(() => {
    if (searchValue) {
      setIsOpen(true)
    } else setIsOpen(groupIdByFacilityId === id)
  }, [searchValue, id, groupIdByFacilityId])

  return (
    <div className="group_facility_menu_item_container">
      <button className="group_facility_menu_item" onClick={handleClickToggle}>
        <ArrowRightIcon className={`button_icon ${activeClassName}`} />
        <span>{name}</span>
      </button>
      {isOpen && (
        <FacilityList
          groupId={id}
          searchValue={searchValue}
          selectFacilityId={selectedFacilityId}
        />
      )}
    </div>
  )
}

const FacilityList = ({ groupId, searchValue, selectFacilityId }) => {
  const facilityList = useShallowEqualSelector(selectLocationsById(groupId))

  const _filteringFacilityList = facilityList.filter((f) =>
    String(f.locationName)
      .toLocaleLowerCase()
      .includes(String(searchValue).toLocaleLowerCase())
  )

  return (
    <div className="facility_list_container">
      {_filteringFacilityList.map((facility) => {
        const isActive = selectFacilityId === facility.id
        return (
          <FacilityItem
            key={facility.id}
            facilityName={facility.locationName}
            facilityId={facility.id}
            isActive={isActive}
          />
        )
      })}
    </div>
  )
}

export default GroupFacilityMenu
